module.exports = __webpack_public_path__ + "img/mi_cctv.cd66748f.png";